var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg46(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96690)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4466_96690",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500002H24V24.5H0V0.500002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4466_96690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42141 10.4135C6.3908 10.1758 6.375 9.9335 6.375 9.6875C6.375 6.58091 8.89336 4.0625 12 4.0625C15.1066 4.0625 17.625 6.58091 17.625 9.6875C17.625 12.7941 15.1066 15.3125 12 15.3125C10.9945 15.3125 10.0507 15.0487 9.23391 14.5865",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5786 10.4135C19.2855 11.3793 20.4375 13.2113 20.4375 15.3125C20.4375 18.4191 17.9191 20.9375 14.8125 20.9375C11.7059 20.9375 9.1875 18.4191 9.1875 15.3125C9.1875 13.2305 10.3187 11.4126 12 10.44",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.185C11.1727 20.6636 10.212 20.9375 9.1875 20.9375C6.08091 20.9375 3.5625 18.4191 3.5625 15.3125C3.5625 12.2059 6.08091 9.6875 9.1875 9.6875C12.0481 9.6875 14.41 11.8228 14.7661 14.5865",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 18.1719C23.2969 21.2785 20.7785 23.7969 17.6719 23.7969H6.32812C3.22153 23.7969 0.703125 21.2785 0.703125 18.1719V6.82813C0.703125 3.72153 3.22153 1.20313 6.32812 1.20313H17.6719C20.7785 1.20313 23.2969 3.72153 23.2969 6.82813V18.1719Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/46.3364abe2a1c8418b4810a18a4caf8137.svg";
export { ForwardRef as ReactComponent };